(function () {
  /* Bundle selector for the cloned PDP.
     The donor's widget is rendered by the Kaching app; this clone carries its markup only,
     so the behaviour is reproduced here, exactly as the donor behaves: picking a colour sets
     it for the WHOLE bundle and swaps every unit image, and the add-to-cart form gets OUR
     variant for that bundle and colour (one line item, priced as the row shows). */
  var MAP = {
  "Single|Black": "67828048527614",
  "Single|Blue": "67828050100478",
  "Single|Pink": "67828050133246",
  "2+2 FREE|Black": "67828320633086",
  "2+2 FREE|Blue": "67828320665854",
  "2+2 FREE|Pink": "67828320698622",
  "3+3 FREE|Black": "67828320731390",
  "3+3 FREE|Blue": "67828320764158",
  "3+3 FREE|Pink": "67828320796926"
};
  var IMG = {
  "Black": "https://cdn.shopify.com/s/files/1/0813/4315/2382/files/elv-elv2-untitled_Gemini3_NanoBananaPro__2026-09-18_13-45-32.png?v=1792698462",
  "Blue": "https://cdn.shopify.com/s/files/1/0813/4315/2382/files/elv-elv3-IMAGE_PRODUIT_1.png?v=1792700331",
  "Pink": "https://cdn.shopify.com/s/files/1/0813/4315/2382/files/elv-elv3-IMAGE_PRODUIT_2_286f4af2-9dd8-4a17-9305-6cb9512671a1.png?v=1792700332"
};
  var PACKS = ['Single', '2+2 FREE', '3+3 FREE'];
  var EXTRA = ['', 'Free shipping + Eloria Facial Exfoliating Towel',
                   'Free shipping + Eloria Facial Exfoliating Towel'];
  var SEL = 'kaching-bundles__bar--selected';
  var BTN_SEL = 'kaching-bundles__swatch-buttons__button--selected';

  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function bars() { return qsa('.kaching-bundles__bar'); }

  function selectedIndex() {
    var b = bars();
    for (var i = 0; i < b.length; i++) if (b[i].classList.contains(SEL)) return i;
    return 0;
  }

  function colourOf(bar) {
    var g = bar && bar.querySelector('.kaching-bundles__swatch-buttons');
    return (g && g.getAttribute('data-value')) || 'Black';
  }

  function paint(bar, colour) {
    qsa('.kaching-bundles__swatch-buttons', bar).forEach(function (g) {
      g.setAttribute('data-value', colour);
      qsa('.kaching-bundles__swatch-buttons__button', g).forEach(function (b) {
        b.classList.toggle(BTN_SEL, b.getAttribute('data-value') === colour);
      });
    });
    var src = IMG[colour];
    if (src) qsa('.kaching-bundles__bar-variant-image', bar).forEach(function (i) {
      i.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'height=200';
    });
  }

  function setInput(form, name, value) {
    var el = form.querySelector('input[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden'; el.name = name;
      form.insertBefore(el, form.firstChild);
    }
    el.value = value;
    return el;
  }

  function sync() {
    var i = selectedIndex(), bar = bars()[i];
    if (!bar) return;
    var id = MAP[(PACKS[i] || 'Single') + '|' + colourOf(bar)];
    if (!id) return;
    qsa('form[action*="/cart/add"]').forEach(function (form) {
      setInput(form, 'id', id);
      var pv = form.querySelector('.product-variant-id');
      if (pv) { pv.value = id; pv.setAttribute('data-selected-id', id); }
      setInput(form, 'quantity', 1);
      qsa('input[name^="properties"]', form).forEach(function (el) { el.parentNode.removeChild(el); });
      if (EXTRA[i]) setInput(form, 'properties[Included free]', EXTRA[i]);
    });
  }

  function selectBar(row) {
    bars().forEach(function (b) { b.classList.toggle(SEL, b === row); });
    var input = row.querySelector('input[type="radio"], input[type="checkbox"]');
    if (input) input.checked = true;
  }

  function onClick(e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.kaching-bundles__swatch-buttons__button');
    if (btn) {
      var bar = btn.closest('.kaching-bundles__bar');
      if (bar) {
        paint(bar, btn.getAttribute('data-value'));
        if (!bar.classList.contains(SEL)) selectBar(bar);
      }
      e.preventDefault(); e.stopPropagation();
      sync();
      return;
    }
    var row = e.target.closest('.kaching-bundles__bar');
    if (row) { selectBar(row); sync(); }
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.getAttribute || (form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[name="add"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'add failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-disabled');
        form.removeEventListener('submit', onSubmit, true);
        form.submit();
      });
  }

  function start() {
    document.addEventListener('click', onClick, true);
    qsa('form[action*="/cart/add"]').forEach(function (f) { f.addEventListener('submit', onSubmit, true); });
    bars().forEach(function (b) { paint(b, colourOf(b)); });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', sync);
})();
